export default __webpack_public_path__ + "static/media/signing-paper.d78fb605.jpg";